import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { FaEdit } from 'react-icons/fa';
import { addNotes, getUserVoucher } from '../../../Services/AdminServices/userSaleServices';
import DataTables from '../../Main/DataTable/DataTables';
import toast from "react-hot-toast";


const Voucher = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Modal states
    const [showModal, setShowModal] = useState(false);
    const [currentVoucher, setCurrentVoucher] = useState(null);
    const [note, setNote] = useState('');

    const handleClose = () => {
        setShowModal(false);
        setNote('');
        setCurrentVoucher(null);
    };

    const handleShow = (voucher) => {
        setCurrentVoucher(voucher);
        setNote(voucher?.note || ''); // ✅ existing note ko textarea me set karo
        setShowModal(true);
    };

    const columns = [
        { name: 'Assigned User Name', selector: row => row.user_name ? row.user_name : "Not Assigned" },
        { name: 'Title', selector: row => row.title ? row.title : "-" },
        {
            name: 'Status',
            selector: row => row?.status === "ACTIVE" ? (
                <h6 className='mb-0'><span className="badge bg-success">{row?.status}</span></h6>
            ) : (
                <h6 className='mb-0'><span className="badge bg-danger">{row?.status}</span></h6>
            )
        },
        {
            name: 'Add Notes',
            cell: row => (
                <Button
                    variant="primary"
                    size="sm"
                    onClick={() => handleShow(row)}
                    className="d-flex align-items-center justify-content-center"
                >
                    <FaEdit />
                </Button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true
        }
    ];

    const getVoucher = async () => {
        setLoading(true);
        const response = await getUserVoucher();
        if (response?.code === 200) {
            setData(response?.result?.discountVouchers?.original?.data);
        }
        setLoading(false);
    };

    const handlePostNotes = async () => {
        if (!currentVoucher?.id) return;

        setLoading(true);
        const body = { note };
        const response = await addNotes(currentVoucher.id, body);

        if (response?.code === 200 || response?.code === 201) {
            toast.success(response?.message)
            handleClose();
            getVoucher(); // refresh table
        } else {
            toast.error(response?.error);
        }
        setLoading(false);
    };

    const handleSave = (e) => {
        e.preventDefault();
        handlePostNotes(); // 👈 Modal save par yeh call hoga
    };

    useEffect(() => { getVoucher(); }, []);

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-lg">
                        <h3 className='fw-bold mb-0'>Vouchers</h3>
                        <p className='text-muted'>Manage Referral User Vouchers </p>
                    </div>

                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <div className="spinner-border text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="col-lg-12">
                            <DataTables filter={true} columns={columns} data={data} />
                        </div>
                    )}
                </div>
            </div>

            {/* Notes Modal */}
            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Note</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSave}>
                        <Form.Group>
                            <Form.Label>Note</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                maxLength={60}
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                            />
                            <div className="text-end text-muted small mt-1">
                                {note.length}/60
                            </div>
                        </Form.Group>
                        <div className="mt-3 text-end">
                            <Button variant="secondary" onClick={handleClose} className="me-2">Close</Button>
                            <Button type="submit" variant="primary">Save</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Voucher;
